/** 카탈로그 분류 (서버 시드 및 필터 공통) */
export const INGREDIENT_CATALOG_CATEGORIES = [
  "전체",
  "직접 추가",
  "장/양념/소스",
  "채소",
  "정육/계란/가공육",
  "수산/건어물",
  "김치/반찬",
  "쌀/잡곡",
  "우유/유제품",
  "과일",
  "통조림/즉석밥/면",
  "간식/떡/빙과",
  "커피/음료",
  "건강식품",
  "베이커리",
  "기타",
];
